import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AppConfigService } from './services';

@NgModule({ imports: [], providers: [AppConfigService, provideHttpClient(withInterceptorsFromDi())] })
export class AppConfigModule {}
